import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({ 
  children, 
  type = 'primary', 
  size = '', 
  to = '', 
  href = '', 
  onClick, 
  className = '',
  ...props 
}) => {
  const classes = `btn btn-${type} ${size ? `btn-${size}` : ''} ${className}`;
  
  if (to) {
    return (
      <Link to={to} className={classes} {...props}>
        {children}
      </Link>
    );
  }
  
  if (href) {
    return (
      <a href={href} className={classes} {...props}>
        {children}
      </a>
    );
  }
  
  return (
    <button className={classes} onClick={onClick} {...props}>
      {children}
    </button>
  );
};

export default Button;